@if (gradientIndex()) {
    <div class="gradient-number-wrapper" [ngClass]="customClassBasedOnNumber">
        <div id="first-num" class="gradient-digit" [class.second-digit]="isMultipleDigit">{{ gradientIndex() }}</div>
    </div>
}
